import React from 'react';
import PropTypes from 'prop-types';

import RegistrationProgress from '@templates/registration/registrationProgress';

const RobotWrapper = ({ isLogin, step, children }) => (
  <section className={'auth-page registration'}>
    <div className={'left-section'}>
      <RegistrationProgress step={step} isLogin={isLogin} />
    </div>
    <div className={'right-section'}>{children}</div>
  </section>
);

export default RobotWrapper;

RobotWrapper.propTypes = {
  step: PropTypes.number,
  isLogin: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};
